import { useAppSelector } from "../../../app/hooks";
import { getHeaderPhone } from "../../helpers/getHeaderPhone";
import { JSX } from "react";

export const Header = (): JSX.Element => {
    const registrationLink = useAppSelector(
        (state) => state.root.registrationLink,
    );
    const telephone = useAppSelector(
        (state) =>
            state.appointment.agendaMoments.activeAgendaMoment?.establishment
                ?.telephone,
    );
    const headerPhone = getHeaderPhone(telephone);
    return (
        <header className="c-header c-header--appointment">
            <a
                href={"https://www.absautoherstel.nl"}
                className="c-header__back"
            >
                <i className="icon-arrow-left color-primary-before" />
                <span className=" font-face-primary-bold">terug</span>
            </a>

            {registrationLink.logo_url ? (
                <img
                    src={registrationLink.logo_url}
                    className="c-header__logo"
                    alt=""
                />
            ) : null}

            <a href={headerPhone.href} className="c-switch__header__help">
                <i className="icomoon-phone icomoon color-primary-before" />
                <span className="font-face-primary-bold">
                    {headerPhone.display}
                </span>
            </a>
        </header>
    );
};
